/**
 * @(#)2019/8/20.
 * YxPopconfirm，气泡确认框
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import "./index.less";
import { Popconfirm } from "antd";
import React, { Component } from "react";
import { l } from "../../config/language";
import { get, merge } from "../../utils/index";
import { omit } from "lodash";
/**
 * @param {boolean} isConfirm 是否需要弹出确认框
 * @param {boolean} visible 是否需要弹出确认框
 *
 * @class YxPopconfirm
 * @extends {Component}
 */
class YxPopconfirm extends Component {
  constructor(props, context) {
    super(props, context);
    this.className = "yx_popconfirm";
    this.state = {
      visible: false,
    };
  }

  /**
   * 控制确认框是否显示
   *
   * @memberof YxPopconfirm
   */
  onVisibleChange = (visible, ...args) => {
    const isConfirm = get(this.props, ["isConfirm", "visible"], true);
    if (isConfirm) {
      this.setState({ visible });
    } else {
      const onConfirm = get(this.props, "onConfirm", () => {});
      const onCancel = get(this.props, "onCancel", () => {});
      visible ? onConfirm(...args) : onCancel(...args);
    }
  };

  killPropagation = (event, type) => {
    event.stopPropagation();
    get(this.props, type, () => {})(event);
  };

  render() {
    const propsClassName = get(this.props, "className", "");
    const className = [propsClassName, this.className].join(" ");
    const popconfirm = merge(
      {
        okText: l("YxPopconfirm.ot", this),
        cancelText: l("YxPopconfirm.ct", this),
      },
      omit(this.props, ["isConfirm"])
    );
    const fixedParam = {
      visible: this.state.visible,
      onVisibleChange: this.onVisibleChange,
      onConfirm: (event) => this.killPropagation(event, "onConfirm"),
      onCancel: (event) => this.killPropagation(event, "onCancel"),
      onClick: (event) => this.killPropagation(event, "onClick"),
    };
    return (
      <Popconfirm
        overlayClassName={className}
        {...popconfirm}
        {...fixedParam}
      ></Popconfirm>
    );
  }
}

export default YxPopconfirm;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxPopconfirm/YxPopconfirm.js